module.exports = __webpack_public_path__ + "img/vegetable-fiddleheads-190x100.e15f9d44.jpg";